export const gridMixin = {
  data() {
    return {
      rowMode: true,
    };
  },
  computed: {
    isRowMode() {
      console.log('Row mode:', this.rowMode);
      return this.rowMode;
    },

    nmbOfAnswers() {
      const choice_config = this.poll.choice_config;
      if (!choice_config) return 0;
      const nmb_of_answers = choice_config.additional_answers.length;
      return nmb_of_answers;
    },

    submitRowHeight() {
      const height = 145 + 58 * this.nmbOfAnswers;
      //const height = 215;
      console.info('submitRowHeight:', height);
      return 'height:' + height + 'px';
    },

    fixedHeight() {
      if (!this.submitMode && !this.mobileView) {
        let height = 108 - 21 - 21;
        height += 12;
        height += 42 * this.nmbOfAnswers;
        return `height: ${height}px; min-height:${height}px`;
      }
      return null;
    },

    cssPage() {
      if (this.isRowMode) {
        if (this.isLayoutCentered) {
          return 'page-row-center';
        }
        return 'page-row';
      }
      if (this.isLayoutCentered) {
        return 'page-column-center';
      }
      return 'page-column';
    },

    cssMode() {
      if (this.poll.options.darkMode) {
        return 'dark-mode';
      }
      return 'light-mode';
    },

    isDarkThem() {
      return this.poll.options.darkMode == true;
    },

    cssFirefoxTheme() {
      if (this.poll.options.darkMode) {
        return 'dark-mode dark-mode-bg-ff';
      }
      return 'light-mode light-mode-bg-ff';
    },

    cssBlurTheme() {
      if (this.poll.options.darkMode) {
        return 'dark-mode dark-mode-bg';
      }
      return 'light-mode light-mode-bg';
    },

    cssTheme() {
      var isFirefox = typeof InstallTrigger !== 'undefined';
      console.log({ isFirefox });
      if (isFirefox) {
        return this.cssFirefoxTheme;
      }
      return this.cssBlurTheme;
    },

    cssCommentsTheme() {
      let css = this.cssFirefoxTheme;
      if (this.isRowMode) {
        css = css + ' comments-block-row';
      } else {
        css = css + ' comments-block-column';
      }
      return css;
    },

    cssParticipateButtonTheme() {
      let css = this.cssFirefoxTheme;
      // if (this.isRowMode) {
      //   css = css + ' comments-block-row';
      // } else {
      //   css = css + ' comments-block-column';
      // }
      return css;
    },

    gridTheme() {
      // if( this.isLayoutCentered) return 'background-color:rgb(238, 69, 64, 08);color:white';
      // return 'background-color:rgba(255, 255, 255, 0.8); ';
      return null;
    },

    isGridCentered() {
      if (this.isMobileDevice) return false;
      return this.isLayoutCentered;
    },

    aligmentCss() {
      if (this.isGridCentered) return 'justify-content-center';
      return 'left-aligment-margin';
    },

    aligmentCssComments() {
      if (this.isGridCentered) return 'justify-content-center';
      if (!this.isRowMode) return 'left-aligment-margin';
      return null;
    },
    aligmentParticipateButton() {
      if (this.isGridCentered) return 'justify-content-center';
      return 'left-aligment-margin';
    },
  },

  methods: {
    updateRowMode() {
      //console.log('dataGrid width:', this.$refs.dataGrid.clientWidth);
      const dataGridWidth = this.$refs.dataGrid.clientWidth;

      const commentGridWidth = this.$refs.commentGrid
        ? this.$refs.commentGrid.clientWidth
        : 0;

      const taskGridWidth = this.$refs.taskGrid
        ? this.$refs.taskGrid.clientWidth
        : 0;

      const widthWidth = window.innerWidth;

      if (
        dataGridWidth + 92 + 2 * 40 + commentGridWidth + taskGridWidth >
        widthWidth
      ) {
        if (this.rowMode) this.rowMode = false;
      } else {
        if (!this.rowMode) this.rowMode = true;
      }
      // alert(
      //   'Row mode was updated to:' +
      //     this.rowMode +
      //     ':' +
      //     widthWidth +
      //     ':' +
      //     dataGridWidth
      // );
      // console.log('Row mode was updated to::', this.rowMode);
    },
  },
};
